export default function Article1() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/594dc4849304cbd3bd7a23edd8bf4d32/085c019ea1217b73a4a5e1e39cd86a89.jpeg"
                alt="PROTECPLUS INGENIERÍA"
                className="h-16 w-auto"
              />
            </a>
            <div className="flex gap-4">
              <a 
                href="/blog"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                Volver al Blog
              </a>
              <a 
                href="/"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-home-line mr-2"></i>
                Inicio
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Article Content */}
      <article className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Article Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4">
            <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full font-medium">
              Normativas
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-calendar-line"></i>
              <span>15 Enero 2025</span>
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-time-line"></i>
              <span>8 min lectura</span>
            </span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nueva Normativa CTE DB-SI 2023: Cambios en Protección contra Incendios
          </h1>
          
          <div className="w-full h-96 rounded-2xl overflow-hidden mb-8">
            <img 
              src="https://public.readdy.ai/ai/img_res/a6d907ccd156a01573dc7de95326ffbf.jpg"
              alt="Nueva Normativa CTE DB-SI 2023"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Article Body */}
        <div className="prose prose-lg max-w-none">
          <div className="bg-emerald-50 border-l-4 border-emerald-500 p-6 rounded-r-lg mb-8">
            <p className="text-gray-700 font-medium">
              El Código Técnico de la Edificación ha introducido importantes actualizaciones en su Documento Básico de Seguridad en caso de Incendio (DB-SI) que entran en vigor en 2023. Estas modificaciones afectan significativamente a los proyectos de protección contra incendios.
            </p>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Principales Cambios Normativos</h2>
          
          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Sectores de Incendio</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            La nueva normativa establece criterios más estrictos para la sectorización de edificios. Se han reducido las superficies máximas permitidas en determinados usos y se han actualizado los requisitos de resistencia al fuego de los elementos separadores.
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Reducción de superficie máxima en sectores de uso residencial público</li>
            <li>Nuevos requisitos para edificios de gran altura</li>
            <li>Actualización de criterios de compartimentación en aparcamientos</li>
            <li>Especificaciones mejoradas para pasos de instalaciones</li>
          </ul>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. Evacuación de Ocupantes</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Se han revisado los criterios de cálculo de ocupación y las condiciones de evacuación, especialmente en edificios de uso público y residencial:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Nuevos coeficientes de ocupación para diferentes usos</li>
            <li>Requisitos actualizados para salidas de emergencia</li>
            <li>Mejoras en señalización y alumbrado de emergencia</li>
            <li>Criterios específicos para personas con movilidad reducida</li>
          </ul>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. Instalaciones de Protección Activa</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Las instalaciones de detección, alarma y extinción han sido objeto de importantes actualizaciones:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Ampliación de casos en los que es obligatoria la detección automática</li>
            <li>Nuevos requisitos para sistemas de extinción automática</li>
            <li>Actualización de criterios para columna seca y BIEs</li>
            <li>Integración con sistemas de control de humos</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Impacto en Proyectos Actuales</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Los proyectos en curso deben adaptarse a la nueva normativa, lo que puede implicar:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Revisión de sectorizaciones existentes</li>
            <li>Actualización de sistemas de detección y extinción</li>
            <li>Mejora de vías de evacuación y señalización</li>
            <li>Adaptación de documentación técnica</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Recomendaciones para el Cumplimiento</h2>
          <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
            <ol className="list-decimal pl-6 text-gray-700 space-y-3">
              <li><strong>Auditoría inicial:</strong> Evaluar el estado actual de las instalaciones respecto a la nueva normativa</li>
              <li><strong>Plan de adaptación:</strong> Desarrollar un calendario de actuaciones prioritarias</li>
              <li><strong>Actualización documental:</strong> Revisar y actualizar toda la documentación técnica</li>
              <li><strong>Formación del personal:</strong> Capacitar a los equipos en los nuevos requisitos</li>
              <li><strong>Seguimiento continuo:</strong> Establecer protocolos de verificación periódica</li>
            </ol>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Conclusiones</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            La actualización del CTE DB-SI 2023 representa un avance significativo en la seguridad contra incendios en edificación. Aunque supone un reto de adaptación, estas mejoras garantizan un mayor nivel de protección para los ocupantes y las propiedades.
          </p>
          <p className="text-gray-700 leading-relaxed mb-4">
            Es fundamental contar con profesionales especializados que puedan guiar el proceso de adaptación y asegurar el cumplimiento normativo completo.
          </p>

          {/* CTA Box */}
          <div className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl p-8 text-white mt-12">
            <h3 className="text-2xl font-bold mb-4">¿Necesitas adaptar tu proyecto a la nueva normativa?</h3>
            <p className="mb-6 text-emerald-50">
              Nuestro equipo de expertos puede ayudarte a cumplir con todos los requisitos del CTE DB-SI 2023.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/citas"
                className="bg-white text-emerald-600 px-6 py-3 rounded-lg font-semibold hover:bg-emerald-50 transition-all text-center whitespace-nowrap"
              >
                Reservar Consulta
              </a>
              <a 
                href="/#contacto"
                className="bg-emerald-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-800 transition-all text-center whitespace-nowrap"
              >
                Contactar Ahora
              </a>
            </div>
          </div>
        </div>

        {/* Back to Blog */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a 
            href="/blog"
            className="inline-flex items-center space-x-2 text-emerald-600 font-semibold hover:text-emerald-700 transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            <span>Volver al Blog</span>
          </a>
        </div>
      </article>
    </div>
  );
}